export const SpanishRoutes = {
  Home: {
    URL: '',
  },
  Register: {
    URL: 'registro',
  },
  RegisterWithPromotion: {
    URL: 'registro/:promotion',
  },
  Login: {
    URL: 'iniciar-sesion',
  },
  Contact: {
    URL: 'contacto',
  },
  TermsOfUse: {
    URL: 'condiciones-uso',
  },
  Cookies: {
    URL: 'cookies',
  },
  Privacy: {
    URL: 'politica-privacidad',
  },
  Hiring: {
    URL: 'politica-contratacion',
  },
  HiringWithRate: {
    URL: 'politica-contratacion/:rate',
  },
  'android-login': {
    URL: 'android-login',
  },
  'android-register': {
    URL: 'android-register',
  },
  Platform: {
    URL: 'plataforma',
  },
};
